/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  FindGisOnWellsParameters,
  GisBody,
  GisBodySimplified,
  GisCreation,
  GisHeader,
  GisToWellMapping,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class GisClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Gis
   * @summary Получение идентификаторов гисов на скважине
   * @request GET:/geology/GIS/for_well/{wellId}
   * @secure
   */
  gisGetGisIdsForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/GIS/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Получение заголовков всех гисов на скважине
   * @request GET:/geology/GIS/for_well/{wellId}/all-headers
   * @secure
   */
  gisGetAllGisHeaders = (wellId: string, params: RequestParams = {}) =>
    this.http.request<GisHeader[], any>({
      path: `/geology/GIS/for_well/${wellId}/all-headers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Получение заголовка гис на скважине по идентификатору
   * @request GET:/geology/GIS/{gisId}
   * @secure
   */
  gisGetGisHeader = (gisId: string, params: RequestParams = {}) =>
    this.http.request<GisHeader, any>({
      path: `/geology/GIS/${gisId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Получение тела гис (с результатами измерений) на скважине по идентификатору
   * @request GET:/geology/GIS/{gisId}/data
   * @secure
   */
  gisGetGisBody = (gisId: string, params: RequestParams = {}) =>
    this.http.request<GisBody, any>({
      path: `/geology/GIS/${gisId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Получение упрощенного тела гис (с результатами измерений) на скважине по идентификатору
   * @request GET:/geology/GIS/{gisId}/data/simplified
   * @secure
   */
  gisGetGisBodySimplified = (
    gisId: string,
    query?: {
      /**
       * Допустимое отклонение между координатами, в процентах от разброса значений по кривой
       * @format double
       * @default 1
       */
      tolerance?: number
      /**
       * Признак используемого алгоритма обработки
       * @default true
       */
      highQualityEnabled?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GisBodySimplified, any>({
      path: `/geology/GIS/${gisId}/data/simplified`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Создание гис на скважине (из ГеоБД)
   * @request POST:/geology/GIS
   * @secure
   */
  gisCreateGises = (data: GisCreation[], params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/GIS`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Gis
   * @summary Поиск ГИС на скважинах по именам или идентификаторам
   * @request POST:/geology/GIS/find_gis_on_wells
   * @secure
   */
  gisFindGisOnWells = (data: FindGisOnWellsParameters, params: RequestParams = {}) =>
    this.http.request<GisToWellMapping[], any>({
      path: `/geology/GIS/find_gis_on_wells`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
